module.exports = {
  emptyMessage: 'El nombre es requerido',
  defaultMessage: 'Nombre inválido',
};
